import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, FilterIcon, UserPlusIcon } from 'lucide-react';
export const ResidentsPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  // Sample resident data
  const residents = [{
    id: 1,
    name: 'Eleanor Johnson',
    age: 83,
    photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '203',
    admissionDate: '2021-08-15',
    careLevel: 'Assisted Living',
    primaryPhysician: 'Dr. Sarah Williams',
    emergencyContact: 'Michael Johnson (Son)',
    status: 'Active'
  }, {
    id: 2,
    name: 'Robert Thompson',
    age: 78,
    photo: 'https://images.unsplash.com/photo-1556474835-b0f3ac40d4d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '115',
    admissionDate: '2022-02-10',
    careLevel: 'Memory Care',
    primaryPhysician: 'Dr. James Chen',
    emergencyContact: 'Patricia Thompson (Daughter)',
    status: 'Active'
  }, {
    id: 3,
    name: 'Margaret Wilson',
    age: 86,
    photo: 'https://images.unsplash.com/photo-1498757581981-8ddb3c0b9b07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '327',
    admissionDate: '2020-11-05',
    careLevel: 'Memory Care',
    primaryPhysician: 'Dr. Sarah Williams',
    emergencyContact: 'David Wilson (Son)',
    status: 'Active'
  }, {
    id: 4,
    name: 'James Davis',
    age: 75,
    photo: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '142',
    admissionDate: '2022-05-20',
    careLevel: 'Independent Living',
    primaryPhysician: 'Dr. Robert Martinez',
    emergencyContact: 'Susan Davis (Wife)',
    status: 'Active'
  }, {
    id: 5,
    name: 'Patricia Moore',
    age: 81,
    photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '219',
    admissionDate: '2021-03-12',
    careLevel: 'Assisted Living',
    primaryPhysician: 'Dr. James Chen',
    emergencyContact: 'Thomas Moore (Son)',
    status: 'Active'
  }, {
    id: 6,
    name: 'Charles Miller',
    age: 79,
    photo: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '156',
    admissionDate: '2022-08-30',
    careLevel: 'Independent Living',
    primaryPhysician: 'Dr. Robert Martinez',
    emergencyContact: 'Elizabeth Miller (Daughter)',
    status: 'Active'
  }, {
    id: 7,
    name: 'Barbara Taylor',
    age: 84,
    photo: 'https://images.unsplash.com/photo-1498757581981-8ddb3c0b9b07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '231',
    admissionDate: '2021-01-15',
    careLevel: 'Assisted Living',
    primaryPhysician: 'Dr. Sarah Williams',
    emergencyContact: 'William Taylor (Husband)',
    status: 'Active'
  }, {
    id: 8,
    name: 'Thomas White',
    age: 77,
    photo: 'https://images.unsplash.com/photo-1556474835-b0f3ac40d4d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '118',
    admissionDate: '2022-04-08',
    careLevel: 'Memory Care',
    primaryPhysician: 'Dr. James Chen',
    emergencyContact: 'Jennifer White (Daughter)',
    status: 'Active'
  }, {
    id: 9,
    name: 'Linda Adams',
    age: 80,
    photo: 'https://images.unsplash.com/photo-1498757581981-8ddb3c0b9b07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '245',
    admissionDate: '2021-09-23',
    careLevel: 'Assisted Living',
    primaryPhysician: 'Dr. Sarah Williams',
    emergencyContact: 'Richard Adams (Son)',
    status: 'Active'
  }, {
    id: 10,
    name: 'Edward Brown',
    age: 82,
    photo: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
    roomNumber: '187',
    admissionDate: '2022-01-05',
    careLevel: 'Memory Care',
    primaryPhysician: 'Dr. Robert Martinez',
    emergencyContact: 'Mary Brown (Wife)',
    status: 'Active'
  }];
  // Filter residents based on search term
  const filteredResidents = residents.filter(resident => resident.name.toLowerCase().includes(searchTerm.toLowerCase()) || resident.roomNumber.toLowerCase().includes(searchTerm.toLowerCase()) || resident.careLevel.toLowerCase().includes(searchTerm.toLowerCase()));
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const handleResidentClick = (residentId: number) => {
    navigate(`/residents/${residentId}`);
  };
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-503">
      <div className="mb-6" data-id="element-504">
        <h1 className="text-2xl font-bold mb-2" data-id="element-505">Residents</h1>
        <p className="text-gray-600" data-id="element-506">
          Manage and view information for all residents at your facility.
        </p>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-507">
        <div className="p-4 border-b border-gray-200 flex flex-wrap items-center justify-between gap-4" data-id="element-508">
          <div className="relative flex-1 min-w-[240px]" data-id="element-509">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-510" />
            <input type="text" placeholder="Search residents..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1f58b0] focus:border-transparent" data-id="element-511" />
          </div>
          <div className="flex gap-3" data-id="element-512">
            <button className="flex items-center px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-513">
              <FilterIcon className="h-4 w-4 mr-2" data-id="element-514" />
              Filter
            </button>
            <button className="flex items-center px-4 py-2 bg-[#1f58b0] text-white rounded-lg hover:bg-[#255db7] transition-colors" data-id="element-515">
              <UserPlusIcon className="h-4 w-4 mr-2" data-id="element-516" />
              Add Resident
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-517">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-518">
            <thead className="bg-gray-50" data-id="element-519">
              <tr data-id="element-520">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-521">
                  Resident
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-522">
                  Room
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-523">
                  Admission Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-524">
                  Care Level
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-525">
                  Primary Physician
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-526">
                  Emergency Contact
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-527">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-528">
              {filteredResidents.map(resident => <tr key={resident.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleResidentClick(resident.id)} data-id="element-529">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-530">
                    <div className="flex items-center" data-id="element-531">
                      <div className="flex-shrink-0 h-10 w-10" data-id="element-532">
                        <img className="h-10 w-10 rounded-full object-cover" src={resident.photo} alt={resident.name} data-id="element-533" />
                      </div>
                      <div className="ml-4" data-id="element-534">
                        <div className="text-sm font-medium text-gray-900" data-id="element-535">
                          {resident.name}
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-536">
                          {resident.age} years
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-537">
                    {resident.roomNumber}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-538">
                    {formatDate(resident.admissionDate)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-539">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${resident.careLevel === 'Memory Care' ? 'bg-purple-100 text-purple-800' : resident.careLevel === 'Assisted Living' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-540">
                      {resident.careLevel}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-541">
                    {resident.primaryPhysician}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-542">
                    {resident.emergencyContact}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-543">
                    <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-544">
                      {resident.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredResidents.length === 0 && <div className="p-8 text-center" data-id="element-545">
            <p className="text-gray-500" data-id="element-546">
              No residents match your search criteria.
            </p>
          </div>}
        <div className="bg-gray-50 px-4 py-3 border-t border-gray-200 sm:px-6" data-id="element-547">
          <div className="flex items-center justify-between" data-id="element-548">
            <div className="text-sm text-gray-700" data-id="element-549">
              Showing{' '}
              <span className="font-medium" data-id="element-550">{filteredResidents.length}</span> of{' '}
              <span className="font-medium" data-id="element-551">{residents.length}</span> residents
            </div>
            <div className="flex-1 flex justify-end" data-id="element-552">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-553">
                <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-554">
                  Previous
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-555">
                  1
                </button>
                <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-556">
                  Next
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </main>;
};